import URLConfig from "@Config/urls/url.config";
import { LinkItemProps } from "@Layouts/sidebar/AppSidebar";

const URL_GLOBAL_PARAMETERS = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.GLOBAL_PARAMETERS
const URL_SCRIPT_PROCESSING = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.SCRIPT_PROCESSING;
const URL_BATCHES = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDSMARTHOLDER.BATCHES;


export const SmartGlobalParametersMenu: Array<LinkItemProps> = [
  {
    name: "Profile application",
    link: URL_GLOBAL_PARAMETERS.PROFILE_APPLICATION,
    level: 3,
  },
  {
    name: "Parametres script processing",
    link: URL_GLOBAL_PARAMETERS.PARAMETERS_SCRIPT_PROCESSING,
    level: 3,
      },  
];

export const ScriptProcessingMenu: Array<LinkItemProps> = [
  {
    name: "Regles",
    link: URL_SCRIPT_PROCESSING.RULES,
    level: 3,
  },
  {
    name: "Consultation",
    link: URL_SCRIPT_PROCESSING.CONSULTATION,
    level: 3,
  },
  {
    name: "Mise à jour carte",
    link: URL_SCRIPT_PROCESSING.CARD_UPDATE,
    level: 3,
  },
  {
    name: "Mise à jour carte par BIN",
    link: URL_SCRIPT_PROCESSING.CARD_UPDATE_PER_BIN,
    level: 3,
  },
];


